import clsx from 'clsx';
import styles from './SegmentedRadioGroup.module.scss';

type SegmentedRadioGroupAllowedChildren = React.ReactElement<
  React.ComponentProps<typeof SegmentedRadioGroupItem>
>;

interface SegmentedRadioGroupProps {
  id: string;
  label: string;
  children:
    | SegmentedRadioGroupAllowedChildren
    | SegmentedRadioGroupAllowedChildren[]
    | (SegmentedRadioGroupAllowedChildren | SegmentedRadioGroupAllowedChildren[])[];
  layout?: 'default' | 'fullWidth';
}

export const SegmentedRadioGroup: React.FC<SegmentedRadioGroupProps> = ({
  id,
  label,
  children,
  layout = 'default',
}) => {
  const labelId = `${id}-label`;

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend} id={labelId}>
        {label}
      </legend>
      <ul aria-labelledby={labelId} className={clsx(styles.group, styles[layout])}>
        {children}
      </ul>
    </fieldset>
  );
};

interface SegmentedRadioGroupItemProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  children: React.ReactNode;
  meta?: React.ReactNode;
}

export const SegmentedRadioGroupItem: React.FC<SegmentedRadioGroupItemProps> = ({
  id,
  name,
  children,
  meta,
  ...props
}) => (
  <li className={styles.item}>
    <input type="radio" className={styles.radio} id={id} name={name} {...props} />
    <label htmlFor={id} className={styles.option}>
      {children}
      {meta && <span className={styles.meta}>{meta}</span>}
    </label>
  </li>
);
